import { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const CustomToastCloseButton = ({ closeToast }) => {
  const timeoutRef = useRef(null);

  useEffect(() => {
    // Set up auto-close timeout for 5 seconds
    timeoutRef.current = setTimeout(closeToast, 5000);

    // Cleanup timeout on component unmount
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [closeToast]);

  const handleManualClose = useCallback(() => {
    // Clear the auto-close timeout when user manually closes
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    closeToast();
  }, [closeToast]);

  return (
    <button
      className="custom-toast-close-btn"
      onClick={handleManualClose}
      aria-label="Close notification"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
};

CustomToastCloseButton.propTypes = {
  closeToast: PropTypes.func.isRequired,
};

export default CustomToastCloseButton;
